import Button from "./Button";
import { Trash } from "lucide-react";

function DeleteButton({ children, ...props }) {
  return (
    <Button {...props} data-testid="Delete Button" px="px-3">
      <Trash className="w-4 h-4" />
      {children}
    </Button>
  );
}

export default DeleteButton;
